/**
 * 微应用全局操作类型
 */
export enum GlobalActions {
  None,
  /**
   * 登录
   */
  SignIn,
  /**
   * 退出登录
   */
  SignOut,
  /**
   * 设置菜单数据
   */
  InitMenu,
  /**
   * 设置reuseTab
   */
  SetReuseTab,
}
